import { Injectable } from '@angular/core';
declare let canvg: any;

@Injectable({ providedIn: 'root' })
export class DownloadService {
    // Source: https://stackoverflow.com/a/33542499/1454074
    downloadCSV(filename: string, data: string): void {
        this.download(filename, new Blob([data], { type: 'text/csv' }));
    }

    download(filename: string, blob: Blob) {
        const elem = window.document.createElement('a');
        elem.href = window.URL.createObjectURL(blob);
        elem.download = filename;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
    }

    /**
     * Download an svg as a png to the client. Takes in width/height of
     * canvas which will determine dimensions of image.
     */
    async downloadSvgImageAsPng(
        svg: SVGElement,
        width: string,
        height: string
    ): Promise<void> {
        const data = new XMLSerializer().serializeToString(svg);
        const canvas = document.createElement('canvas');
        canvas.setAttribute('width', width);
        canvas.setAttribute('height', height);
        const fileName = 'AnalyticsImage.png';
        canvg(canvas, data, {
            renderCallback: () => {
                canvas.toBlob((blob) => {
                    this.download(fileName, blob);
                });
            }
        });
    }
}
